
<template>
  <div>
    <v-dialog :value="dialog" scrollable persistent max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">Editando endereço funcionário</span>
        </v-card-title>
        <v-card-text>
          <AddressForm :address="employee.data.attributes.address.data.attributes"></AddressForm>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <f-btn cancel @click="closeDialog"></f-btn>
          <f-btn save @click="emitUpdate"></f-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import validations from "@/mixins/validations.js"
export default {
  name: 'EmployeeEditAddressDialog',
  mixins: [ validations ],
  props: {
    employee:{
      type: Object,
      default: () => { return {} },
    },
    change_dialog:{
      type: Boolean,
      default: false,
    }
  },
  components: {
    AddressForm: () => import('@/_backoffice/_registrations/components/shared/forms/AddressForm.vue'),
  },
  data() {
    return {
      new_employee:{
        id: null
      },
      dialog: false,
    }
  },
  methods: {
    emitUpdate(){
      this.prepareAddressEmployee()
      this.$emit('update', this.new_employee)
    },
    closeDialog(){
      this.$emit('close')
    },
    prepareAddressEmployee() {
      this.new_employee.id = this.employee.data.attributes.id
      this.new_employee.address_attributes = this.employee.data.attributes.address.data.attributes
    },
  },
  watch:{
    change_dialog(nv, old){
      this.dialog = nv
    },

  }
}
</script>